import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import Container from "@/components/ContentContainer/Container";
import MoreButton from "@/components/MoreButton/MoreButton";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import Skeleton from "@/components/Skeleton/Skeleton";
import StatusTag from "@/components/StatusTag/StatusTag";
import useTrackOnLoad from "@/hooks/useTrackPageview";
import { DeleteOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import DeletePackagingMaterialAction from "../DeletePackagingMaterialAction";
import { useGetPackagingMaterial } from "../usePackagingMaterials";
import styles from "./PackagingMaterialDetail.module.scss";
import PackagingMaterialDetails from "./PackagingMaterialDetails";
import PackagingMaterialImpact from "./PackagingMaterialImpact";
import PackagingMaterialRelations from "./PackagingMaterialRelations";
import PackagingMaterialUnitConversion from "./PackagingMaterialUnitConversion";

export default function PackagingMaterialDetail() {
  useTrackOnLoad("Packaging Material Viewed");

  const { materialId: id } = useParams();
  const materialId = Number(id);
  const navigate = useNavigate();

  const { data: material, isLoading, isFetching } = useGetPackagingMaterial({ materialId });

  return (
    <Flex
      gap={8}
      vertical
    >
      <PageHeader
        loading={isLoading}
        title={material?.name}
        right={
          <>
            {isLoading ? (
              <>
                <Skeleton style={{ width: "90px", height: "24px" }} />
                <Skeleton style={{ width: "24px", height: "24px" }} />
              </>
            ) : (
              <>
                {material && (
                  <>
                    {isFetching ? (
                      <Skeleton style={{ width: "90px", height: "24px" }} />
                    ) : (
                      <StatusTag
                        background="white"
                        status={material.status}
                        showIcon={false}
                      />
                    )}

                    <MoreButton
                      actions={
                        <>
                          <DeletePackagingMaterialAction
                            materials={[material]}
                            onSucces={() => navigate("/matching/packaging")}
                          >
                            <>
                              <ActionsPopOverItem
                                disabled={material.packaging_relations > 0}
                                danger
                                icon={<DeleteOutlined />}
                              >
                                Delete material
                              </ActionsPopOverItem>
                            </>
                          </DeletePackagingMaterialAction>
                        </>
                      }
                    />
                  </>
                )}
              </>
            )}
          </>
        }
      />
      <Flex>
        <Container
          padding={false}
          className={styles.MaterialDetail}
        >
          <PackagingMaterialImpact materialId={materialId} />
          <PackagingMaterialUnitConversion materialId={materialId} />
          <PackagingMaterialRelations materialId={materialId} />
        </Container>
        <PackagingMaterialDetails materialId={materialId} />
      </Flex>
    </Flex>
  );
}
